import Vue from "vue"
import Vuex from "vuex"
import { baseURL } from "@/utils/request.js"
import axios from "axios"
import {
  user_user_info,
  user_user_rule
} from "@/api/index"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: null,
    lzp_token: null,

    userInfo: null,
    isDeposit: "hidden",

    userRule: [],
    menus: null,

    orderId: null,

    cityData: [],
    addressData: {},

    applicationInfo: null,
    querySearch: ["key"],
    querySearch_long: ["key"],
  },
  getters: {},
  mutations: {
    // token
    SET_TOKEN: (state, token) => {
      state.token = token
      window.localStorage.setItem("token", token)
    },
    REMOVE_TOKEN: (state) => {
      state.token = null
      window.localStorage.removeItem("token")
    },

    // lzp_token
    SET_LZP_TOKEN: (state, token) => {
      state.lzp_token = token
      window.localStorage.setItem("lzp_token", token)
    },
    REMOVE_LZP_TOKEN: (state) => {
      state.lzp_token = null
      window.localStorage.removeItem("lzp_token")
    },

    // userInfo
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = userInfo
      window.localStorage.setItem("userInfo", JSON.stringify(userInfo))
    },
    REMOVE_USERINFO: (state) => {
      state.userInfo = null
      window.localStorage.removeItem("userInfo")
    },

    // isDeposit
    SET_ISDEPOSIT: (state, isDeposit) => {
      state.isDeposit = isDeposit
      window.localStorage.setItem("isDeposit", isDeposit)
    },
    REMOVE_ISDEPOSIT: (state) => {
      state.isDeposit = "hidden"
      window.localStorage.removeItem("isDeposit")
    },

    // routes
    SET_USERROUTES: (state, userRule) => {
      state.userRule = userRule
      window.localStorage.setItem("userRule", JSON.stringify(userRule))
    },
    REMOVE_USERROUTES: (state) => {
      state.userRule = null
      window.localStorage.removeItem("userRule")
    },

    // menus
    SET_MENUS: (state, menus) => {
      state.menus = menus
      window.localStorage.setItem("menus", JSON.stringify(menus))
    },
    REMOVE_MENUS: (state) => {
      state.menus = null
      window.localStorage.removeItem("menus")
    },

    // orderId
    SET_ORDERID: (state, id) => {
      state.orderId = id
    },
    REMOVE_ORDERID: (state, id) => {
      state.orderId = null
    },

    // cityData
    SET_CITYDATA: (state, city) => {
      state.cityData = city
    },

    // addressData
    SET_ADDRESSDATA: (state, address) => {
      state.addressData = address
    },

    // applicationInfo
    SET_APPLICATIONINFO: (state, info) => {
      state.applicationInfo = info
      window.localStorage.setItem("applicationInfo", JSON.stringify(info))
    },
    REMOVE_APPLICATIONINFO: (state) => {
      state.applicationInfo = []
      window.localStorage.removeItem("applicationInfo")
    },

    // querySearch
    SET_QUERYSEARCH: (state, info) => {
      state.querySearch = info
      window.localStorage.setItem("querySearch", JSON.stringify(info))
    },
    // querySearch_long
    SET_QUERYSEARCHLONG: (state, info) => {
      state.querySearch_long = info
      window.localStorage.setItem("querySearch_long", JSON.stringify(info))
    },
  },
  actions: {
    // 获取地区数据
    getAreaList({ commit }) {
      axios.get(`${baseURL}/common/area.json`).then(res => {
        commit("SET_CITYDATA", res.data.city)
      })
    },
    // 获取地区识别数据
    getAddressList({ commit }) {
      axios.request({
        url: `${baseURL}/common/address.json`,
        responseType: "text"
      }).then(res => {
        commit("SET_ADDRESSDATA", JSON.parse(res.data))
      })
    },
    // 获取用户信息
    getUserUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        user_user_info().then((res) => {
          commit("SET_USERINFO", res.data)
          let plugin_ids = res.data.merchant.plugin_ids
          if (plugin_ids && plugin_ids.includes("3")) {
            commit("SET_ISDEPOSIT", "normal")
          }
          resolve(res.data)
        }).catch((e) => {
          reject()
        })
      })
    },
    // 获取后端权限生成动态菜单
    getUserUserRuleList({ state, commit }) {
      return new Promise((resolve, reject) => {
        user_user_rule().then((res) => {
          const userInfo = state.userInfo
          let routesList = []
          if (userInfo.group_id == 1) {
            routesList = [{
              title: "商家配置",
              name: "setting",
              icon: "setting",
              path: "/setting",
              component: () => import("@/views/setting/index"),
              meta: { title: "商家配置", keepAlive: true },
            }]
          }
          let userRule = res.data
          commit("SET_USERROUTES", userRule)

          let userRuleList = userRule.filter((item) => item.remark && item.ismenu == 1)
          for (let i = 0; i < userRuleList.length; i++) {
            let remark = userRuleList[i].remark.split("-")
            if (remark[1] == 1) {
              if (!userRuleList[i].show && userRuleList[i].status == "normal") {
                routesList.push({
                  title: userRuleList[i].title,
                  name: remark[0].replaceAll("/", ""),
                  icon: userRuleList[i].icon,
                  path: remark[0],
                  component: () => import(`@/views${remark[0]}/index`),
                  meta: { title: userRuleList[i].title, keepAlive: true },
                })
              }
            } else {
              let subordinate = userRuleList[i].subordinate
              let children = []
              for (let a = 0; a < subordinate.length; a++) {
                if (!subordinate[a].show && subordinate[a].status == "normal") {
                  children.push({
                    name: subordinate[a].remark.replaceAll("/", ""),
                    path: subordinate[a].remark,
                    component: () => import(`@/views${subordinate[a].remark}`),
                    meta: {
                      title: subordinate[a].title,
                      activeMenu: remark[0],
                      keepAlive: subordinate[a].remark == "/plugin/box" ? false : true,
                    },
                  })
                }
              }
              routesList.push({
                title: userRuleList[i].title,
                icon: userRuleList[i].icon,
                path: remark[0],
                redirect: children[0].path,
                component: () => import(`@/views${remark[0]}/box`),
                children,
              })
            }
          }
          commit("SET_MENUS", routesList)
          resolve(routesList)
        }).catch((e) => {
          reject()
        })
      })
    },
    // 根据页面获取权限
    getPermission({ state }, path) {
      return new Promise((resolve, reject) => {
        let userRule = state.userRule
        let permission = userRule.filter((item) => item.extend == path)
        let permissionList = []
        if (permission.length) {
          if (permission[0].remark == "other") {
            permissionList = [{
              name: "other",
              status: permission[0].status == "normal" && !permission[0].show ? true : false,
            }]
          } else {
            let permissionItem = permission[0].subordinate
            permissionList = permissionItem.map((item) => {
              return {
                name: item.name,
                status: item.status == "normal" && !item.show ? true : false,
              }
            })
          }
        } else {
          let permissionTwo = userRule.map((item) => item.subordinate.filter((fItem) => fItem.remark == path))
          let permissionTwoItem = permissionTwo.filter((item) => item.length)[0]
          if (permissionTwoItem && permissionTwoItem.length) {
            let permissionItem = permissionTwoItem[0].subordinate
            permissionList = permissionItem.map((item) => {
              return {
                name: item.name,
                status: item.status == "normal" && !item.show && !permissionTwoItem[0].show ? true : false,
              }
            })
          }
        }
        resolve(
          permissionList.length ? permissionList.reduce((obj, item) => ({ ...obj, [item.name]: item.status }), {}) : null
        )
      })
    },
    // 退出登录
    outLoginClick({ commit }) {
      commit("REMOVE_TOKEN")
      commit("REMOVE_USERINFO")
      commit("REMOVE_ISDEPOSIT")
      commit("REMOVE_USERROUTES")
      commit("REMOVE_MENUS")
      commit("REMOVE_APPLICATIONINFO")
    },
    // 如有缓存直接赋值vuex 不去请求接口
    loadLocal({ commit }) {
      const token = window.localStorage.getItem("token")
      if (token && token != "undefined") {
        commit("SET_TOKEN", token)
      }
      const lzp_token = window.localStorage.getItem("lzp_token")
      if (lzp_token && lzp_token != "undefined") {
        commit("SET_LZP_TOKEN", lzp_token)
      }
      const userInfo = window.localStorage.getItem("userInfo")
      if (userInfo && userInfo != "undefined") {
        commit("SET_USERINFO", JSON.parse(userInfo))
      }
      const isDeposit = window.localStorage.getItem("isDeposit")
      if (isDeposit && isDeposit != "undefined") {
        commit("SET_ISDEPOSIT", isDeposit)
      }
      const userRule = window.localStorage.getItem("userRule")
      if (userRule && userRule != "undefined") {
        commit("SET_USERROUTES", JSON.parse(userRule))
      }
      const menus = window.localStorage.getItem("menus")
      if (menus && menus != "undefined") {
        commit("SET_MENUS", JSON.parse(menus))
      }
      const applicationInfo = window.localStorage.getItem("applicationInfo")
      if (applicationInfo && applicationInfo != "undefined") {
        commit("SET_APPLICATIONINFO", JSON.parse(applicationInfo))
      }
      const querySearch = window.localStorage.getItem("querySearch")
      if (querySearch && querySearch != "undefined") {
        commit("SET_QUERYSEARCH", JSON.parse(querySearch))
      }
      const querySearch_long = window.localStorage.getItem("querySearch_long")
      if (querySearch_long && querySearch_long != "undefined") {
        commit("SET_QUERYSEARCHLONG", JSON.parse(querySearch_long))
      }
    },
  },
  modules: {},
})
